<!--  -->
<template>
    <div class="business-content-main outconfirm-content">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div>
            <div class="search-ctn" style="min-height:0">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
                    <el-button v-if="permission.batchComfirm" size="small" type="warning" icon="el-icon-document-copy" class="search-btn" @click="batchComfirms()">{{
                        permission.batchComfirm
                    }}</el-button>
                    <el-button v-if="permission.scanConfirm" size="small" type="warning" class="search-btn" @click="scanComfirms()">{{ permission.scanConfirm }}</el-button>
                    <div v-if="permission.scanConfirm" class="search-name" style="color: red">（使用扫码确认功能请确保焦点在标签输入框内，并检查电脑的输入法是否英文输入）</div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    highlight-current-row
                    style="width: 100%;"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border=""
                    :data="tableData"
                    height="500"
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :row-class-name="tableRowClassName"
                    :tableCode="tableCode"
                    @row-click="rowClick"
                    :row-key="getRowKeys"
                    @sort-change="sortChange"
                    v-el-table-infinite-scroll="tableLoad"
                >
                    <el-table-column type="selection" width="50" reserve-selection :selectable="selectInit"></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.OrderCode.IsShow"
                        :width="columnShowSets.OrderCode.Width > 0 ? columnShowSets.OrderCode.Width + 'px' : '180px'"
                        :label="columnShowSets.OrderCode.ColumnName"
                        prop="OrderCode"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope"> {{ scope.row.OrderCode }}</template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.EntpCusName.IsShow"
                        :min-width="columnShowSets.EntpCusName.Width > 0 ? columnShowSets.EntpCusName.Width + 'px' : '200px'"
                        :label="columnShowSets.EntpCusName.ColumnName"
                        prop="EntpCusName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.CallNum.IsShow"
                        :min-width="columnShowSets.CallNum.Width > 0 ? columnShowSets.CallNum.Width + 'px' : '120px'"
                        :label="columnShowSets.CallNum.ColumnName"
                        prop="CallNum"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="PayTypeName"
                        v-if="columnShowSets.PayTypeName.IsShow"
                        :min-width="columnShowSets.PayTypeName.Width > 0 ? columnShowSets.PayTypeName.Width + 'px' : '100px'"
                        :label="columnShowSets.PayTypeName.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="OutWarehouseStateName"
                        v-if="columnShowSets.OutWarehouseStateName.IsShow"
                        :width="columnShowSets.OutWarehouseStateName.Width > 0 ? columnShowSets.OutWarehouseStateName.Width + 'px' : '100px'"
                        :label="columnShowSets.OutWarehouseStateName.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.IsAllNotOut" class="out-active">不需出仓</i>
                            <i v-else-if="scope.row.IsDelivery" class="out-active">已出仓</i>
                            <i v-else>未出仓</i>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="OrderType"
                        v-if="columnShowSets.OrderType.IsShow"
                        :width="columnShowSets.OrderType.Width > 0 ? columnShowSets.OrderType.Width + 'px' : '80px'"
                        :label="columnShowSets.OrderType.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.OrderType == 0" class="c-active">销售收款</i>
                            <i v-else class="out-active">销售退货</i>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="ConfirmStateName"
                        v-if="columnShowSets.ConfirmStateName.IsShow"
                        :width="columnShowSets.ConfirmStateName.Width > 0 ? columnShowSets.ConfirmStateName.Width + 'px' : '80px'"
                        :label="columnShowSets.ConfirmStateName.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.IsCanStateBack" class="confirm-active">{{ scope.row.ConfirmStateName }}</i>
                            <i v-else>{{ scope.row.ConfirmStateName }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="OrderAmount"
                        v-if="columnShowSets.OrderAmount.IsShow"
                        :width="columnShowSets.OrderAmount.Width > 0 ? columnShowSets.OrderAmount.Width + 'px' : '100px'"
                        :label="columnShowSets.OrderAmount.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.OrderAmount : -scope.row.OrderAmount }}</template>
                    </el-table-column>
                    <el-table-column
                        prop="DiscountAmount"
                        v-if="columnShowSets.DiscountAmount.IsShow"
                        :min-width="columnShowSets.DiscountAmount.Width > 0 ? columnShowSets.DiscountAmount.Width + 'px' : '100px'"
                        :label="columnShowSets.DiscountAmount.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="ShipAmount"
                        v-if="columnShowSets.ShipAmount.IsShow"
                        :min-width="columnShowSets.ShipAmount.Width > 0 ? columnShowSets.ShipAmount.Width + 'px' : '100px'"
                        :label="columnShowSets.ShipAmount.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.CalcAmount.IsShow"
                        :width="columnShowSets.CalcAmount.Width > 0 ? columnShowSets.CalcAmount.Width + 'px' : '100px'"
                        :label="columnShowSets.CalcAmount.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{
                                scope.row.OrderType == 0
                                    ? (scope.row.OrderAmount + scope.row.ShipAmount - scope.row.DiscountAmount).toFixed(2)
                                    : -(scope.row.OrderAmount + scope.row.ShipAmount - scope.row.DiscountAmount).toFixed(2)
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="Paid"
                        v-if="columnShowSets.ActualMoney.IsShow"
                        :width="columnShowSets.ActualMoney.Width > 0 ? columnShowSets.ActualMoney.Width + 'px' : '100px'"
                        :label="columnShowSets.ActualMoney.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.IsCanStateBack ? (scope.row.OrderType == 0 ? scope.row.Paid.toFixed(2) : -scope.row.Paid.toFixed(2)) : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="Remark"
                        v-if="columnShowSets.Remark.IsShow"
                        :min-width="columnShowSets.Remark.Width > 0 ? columnShowSets.Remark.Width + 'px' : '200px'"
                        :label="columnShowSets.Remark.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="SName"
                        v-if="columnShowSets.SName.IsShow"
                        :min-width="columnShowSets.SName.Width > 0 ? columnShowSets.SName.Width + 'px' : '80px'"
                        :label="columnShowSets.SName.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="CreateTime"
                        sortable="custom"
                        v-if="columnShowSets.CreateTime.IsShow"
                        :min-width="columnShowSets.CreateTime.Width > 0 ? columnShowSets.CreateTime.Width + 'px' : '160px'"
                        :label="columnShowSets.CreateTime.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="ConfirmTime"
                        sortable="custom"
                        v-if="columnShowSets.ConfirmTime.IsShow"
                        :min-width="columnShowSets.ConfirmTime.Width > 0 ? columnShowSets.ConfirmTime.Width + 'px' : '160px'"
                        :label="columnShowSets.ConfirmTime.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="Confirmer"
                        v-if="columnShowSets.Confirner.IsShow"
                        :min-width="columnShowSets.Confirner.Width > 0 ? columnShowSets.Confirner.Width + 'px' : '80px'"
                        :label="columnShowSets.Confirner.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <el-button
                                v-if="permission.confirm && !scope.row.IsCanStateBack && scope.row.IsDelivery"
                                :title="permission.confirm"
                                size="mini"
                                type="text"
                                @click="confirm(scope.row)"
                                >{{ permission.confirm }}</el-button
                            >
                            <el-button
                                v-if="permission.stateBack && scope.row.IsCanStateBack"
                                :title="permission.stateBack"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="stateBack(scope.row)"
                                >{{ permission.stateBack }}</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
                <div class="section-summary" v-if="isShowSummary">
                    <div>
                        <span>合计：{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
            <div class="section-title">
                <div>
                    <span>{{ !orderCode ? '' : '【' + orderCode + '】' }}订单明细</span>
                </div>
            </div>
            <div>
                <el-table
                    v-loading="loading"
                    class="detail-table"
                    :data="orderGoodsData"
                    style="width: 100%"
                    height="200px"
                    border=""
                    :header-cell-style="{ background: '#F2F6FC' }"
                >
                    <el-table-column prop="SortNum" label="序号" width="80"></el-table-column>
                    <el-table-column prop="APCode" label="汽配编码" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="GoodName" label="汽配名称" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="AutoSerise" label="车型" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Count" label="数量" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.Count : -scope.row.Count }}</template>
                    </el-table-column>
                    <el-table-column prop="Unit" label="单位" width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Price" label="销售价" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.Price.toFixed(2) : -scope.row.Price.toFixed(2) }}</template>
                    </el-table-column>
                    <el-table-column prop="PriceAmount" label="销售总价" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{
                            scope.row.OrderType == 0 ? (scope.row.Count * scope.row.Price).toFixed(2) : -(scope.row.Count * scope.row.Price).toFixed(2)
                        }}</template>
                    </el-table-column>
                    <el-table-column prop="WarehousedCount" label="已出库数" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.WarehousedCount : -scope.row.WarehousedCount }}</template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                title="出库单搜索"
                :visible.sync="dialogVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="search-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="客户">
                            <el-select
                                ref="search_0"
                                class="search-item"
                                size="small"
                                style="width: 100%"
                                v-model="searchData.Keyword"
                                remote
                                filterable
                                allow-create
                                clearable
                                placeholder="客户名称/电话"
                                :remote-method="searchCustom"
                                v-select-scroll-more="searchCustomLoad"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                        <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单号">
                            <el-input
                                class="search-item"
                                style="width: 100%"
                                size="small"
                                v-model.trim="searchData.OrderCode"
                                v-filter-special-char="searchData.OrderCode"
                                placeholder="销售/退货单号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="支付方式">
                            <el-select class="search-item" style="width: 100%" size="small" v-model="searchData.PayType" multiple collapse-tags clearable>
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="物流状态">
                            <el-select ref="search_3" class="search-item" style="width: 100%" size="small" v-model="searchData.DeliveryState">
                                <el-option v-for="item in deliStateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="确认状态">
                            <el-select class="search-item" style="width: 100%" size="small" v-model="searchData.State">
                                <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单据类型">
                            <el-select class="search-item" style="width: 100%" size="small" v-model="searchData.OrderType">
                                <el-option v-for="item in orderTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="业务员">
                            <el-select v-model="searchData.SId" style="width: 100%" class="search-item" size="small" filterable clearable placeholder="请选择">
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="确认人">
                            <el-select v-model="searchData.ConfirmerId" style="width: 100%" class="search-item" size="small" filterable clearable placeholder="请选择">
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime1"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate1TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="确认日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime2"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate2TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                title="扫码确认"
                :visible.sync="dialogScanVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="scan-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogScanVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="单号">
                            <el-input
                                class="search-name"
                                ref="inputdata"
                                v-model="scanData"
                                clearable
                                placeholder="请扫描销售单或退货单二维码"
                                size="small"
                                style="width: 250px"
                                @blur="inputblur()"
                                @change="inputDataChange()"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="确认单据" :visible.sync="confirmVisible" width="1000px">
                <div class="dialog-content" v-if="confirmVisible">
                    <ConfirmReceipt ref="confirmReceipt" @closeConfirm="closeConfirm(arguments)" :confirmData="currentRow" :type="0"></ConfirmReceipt>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import ConfirmReceipt from '@/components/business/revenue_n/confirmOutOrder';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        ConfirmReceipt
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                });
            }
        }
    },
    data() {
        return {
            summaryStr: '',
            orderCode: '',
            datetime1: [],
            datetime2: [],
            loading: '',
            tableCode: 'DeliveryConfirms',
            multipleSelection: null,
            dialogVisible: false,
            dialogScanVisible: false,
            firstScanOrder: true,
            confirmVisible: false,
            scanData: '',
            dataindex: 0,
            stopFresh: false,
            stopRequest: false,
            isShowSummary: false,
            isStartSearch: false,
            searchData: {
                State: '',
                PayType: [],
                Keyword: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                ConfirmerId: '',
                SortProp: '',
                SortType: '',
                OrderType: '',
                DeliveryState: '1',
                page: 1,
                limit: this.commonPageSize
            },
            searchParams: {},
            currentRow: {},
            tableData: [],
            orderGoodsData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未确认', Value: '0' },
                { Text: '已确认', Value: '1' }
            ],
            orderTypeList: [
                { Text: '全部', Value: '' },
                { Text: '销售单', Value: '0' },
                { Text: '销售退货单', Value: '1' }
            ],
            deliStateList: [
                { Text: '全部', Value: '' },
                { Text: '未出仓', Value: '0' },
                { Text: '已出仓', Value: '1' },
                { Text: '不需出仓', Value: '2' }
            ],
            SIdList: [],
            payWayList: [],
            idList: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            columnShowSets: {
                OrderCode: { ColumnName: '', IsShow: false, Width: 0 },
                EntpCusName: { ColumnName: '', IsShow: false, Width: 0 },
                CallNum: { ColumnName: '', IsShow: false, Width: 0 },
                PayTypeName: { ColumnName: '', IsShow: false, Width: 0 },
                ConfirmTime: { ColumnName: '', IsShow: false, Width: 0 },
                OutWarehouseStateName: { ColumnName: '', IsShow: false, Width: 0 },
                OrderAmount: { ColumnName: '', IsShow: false, Width: 0 },
                DiscountAmount: { ColumnName: '', IsShow: false, Width: 0 },
                ShipAmount: { ColumnName: '', IsShow: false, Width: 0 },
                CalcAmount: { ColumnName: '', IsShow: false, Width: 0 },
                Confirner: { ColumnName: '', IsShow: false, Width: 0 },
                Remark: { ColumnName: '', IsShow: false, Width: 0 },
                ConfirmStateName: { ColumnName: '', IsShow: false, Width: 0 },
                SName: { ColumnName: '', IsShow: false, Width: 0 },
                CreateTime: { ColumnName: '', IsShow: false, Width: 0 },
                OrderType: { ColumnName: '', IsShow: false, Width: 0 },
                ActualMoney: { ColumnName: '', IsShow: false, Width: 0 }
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if(this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.permission = this.$util.getPermission('DeliveryConfirms');
        this.getTableData();
        this.initSearchSelectData();
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.dialogVisible = true;
                that.isStartSearch = true;
            }
            if (key === 13) {
                if (!that.dialogScanVisible) {
                    if (that.dialogVisible) {
                        that.handleSearch();
                        that.isStartSearch = false;
                    } else if (!that.confirmVisible) {
                        if (that.currentRow && (that.currentRow.IsDelivery || that.currentRow.IsAllNotOut)) {
                            if (that.currentRow.OrderId && !that.currentRow.IsCanStateBack && !that.currentRow.IsCanStateBack) that.confirmVisible = true;
                        } else {
                            that.$util.warningMsg('订单还未出仓，请待出仓后再进行确认');
                            return;
                        }
                    } else if (that.confirmVisible) {
                        if (that.$refs.confirmReceipt) {
                            that.$refs.confirmReceipt.submitForm();
                        }
                    }
                }
            }
            if (key === 27) {
                if (that.dialogVisible) {
                    that.dialogVisible = false;
                    that.isStartSearch = false;
                } else if (that.confirmVisible) that.confirmVisible = false;
            }
            //下键
            if (key == 40) {
                if (that.dataindex != that.tableData.length - 1) {
                    if (that.currentRow && that.currentRow.OrderId) {
                        that.dataindex++;
                    } else that.dataindex = 0;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.currentRow);
                            that.getOrderDetail();
                        }
                    });
                }
            }
            //上键
            if (key == 38) {
                if (that.dataindex != 0) {
                    that.dataindex--;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.currentRow);
                            that.getOrderDetail();
                        }
                    });
                }
            }
        },
        tableLoad() {
            if (!this.stopFresh && this.firstScanOrder) {
                //第一页还没有数据就去请求第二页，想太多了吧`(*>﹏<*)′
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
            this.getOrderDetail();
        },
        getOrderDetail() {
            let item = this.currentRow;
            if (item) {
                this.orderCode = item.OrderCode;
                this.loading = true;
                let url = '';
                if (item.OrderType == 0) url = '/api/EntpSaleOrder/GetOrderItemsById';
                else url = '/api/EntpSaleReturnOrder/GetEntpCusReturnOrderGoodsListById';
                this.$util
                    .axiosGet({
                        url: url,
                        data: {
                            OrderId: item.OrderId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            this.orderGoodsData = res.data;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        initSearchSelectData() {
            //可以把这些常用的数据放到缓存里面
            this.getPay();
            this.getSIdList();
            this.searchCustom();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            if (val.length > 0) {
                this.isShowSummary = true;
                let sa = 0; //销售总额
                let sahj = 0; //合计
                let yh = 0;
                let yf = 0;
                let shhj = 0; //实收总合计
                for (let i = 0; i < val.length; i++) {
                    idList.push(val[i].OrderId);
                    let oa = val[i].OrderAmount;
                    let ss = val[i].Paid;
                    if (val[i].OrderType == 0) {
                        sa += oa;
                        sahj += val[i].OrderAmount + val[i].ShipAmount - val[i].DiscountAmount;
                        if (val[i].IsCanStateBack) shhj += ss;
                    } else {
                        sa -= oa;
                        sahj -= oa;
                        if (val[i].IsCanStateBack) shhj -= ss;
                    }
                    yh += val[i].DiscountAmount;
                    yf += val[i].ShipAmount;
                }

                this.summaryStr =
                    '销售总额 = ' +
                    sa.toFixed(2) +
                    '；  优惠总额 = ' +
                    yh.toFixed(2) +
                    '；  运费总额 = ' +
                    yf.toFixed(2) +
                    '；  总合计 = ' +
                    sahj.toFixed(2) +
                    '；  实收总金额 = ' +
                    shhj.toFixed(2);

                this.idList = idList;
            }
        },
        resetSearch() {
            this.searchData = {
                State: '',
                PayType: [],
                Keyword: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                ConfirmerId: '',
                SortProp: '',
                SortType: '',
                OrderType: '',
                DeliveryState: '1',
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime1 = [];
            this.datetime2 = [];
            this.searchCustom('');
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            let that = this;
            if (!that.stopRequest) {
                if (that.searchData.page == 1) {
                    that.searchParams = { ...that.searchData };
                } else {
                    that.searchParams.page = that.searchData.page;
                }
                that.stopFresh = true;
                that.stopRequest = true;
                that.$util
                    .axiosPost({
                        url: '/api/RevenueManagement_N/GetCusOrdersConfirmList',
                        data: that.searchParams
                    })
                    .then(res => {
                        let data = res.data;
                        that.tableDataLength = res.count;
                        if (!data) {
                            if (that.searchData.page == 1) this.tableData = [];
                            return;
                        }

                        let list = [...that.tableData, ...data];
                        that.tableData = list;
                        that.stopFresh = data.length < that.searchData.limit;
                    })
                    .finally(() => {
                        that.stopRequest = false;
                    });
            }
        },
        handleSearch() {
            this.dataindex = 0;
            this.firstScanOrder = true;
            this.tableData = [];
            if (this.$refs.multipleTable) this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        stateBack(item) {
            let that = this;
            if (!that.dialogScanVisible) {
                if (item.OrderId) {
                    that.$confirm('您确定要将该确认状态回退到未确认状态吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            //预留批量回退的功能，但目前的业务可能不做
                            let ids = [];
                            ids.push(item.OrderId);
                            that.$util
                                .axiosPost({
                                    url: '/api/RevenueManagement_N/SaleConfirmStateBack',
                                    data: {
                                        OrderIds: ids
                                    }
                                })
                                .then(res => {
                                    that.$util.successMsg('状态回退成功');
                                    that.handleSearch();
                                })
                                .catch(() => {});
                        })
                        .catch(() => {});
                } else {
                    that.$util.warningMsg('订单信息异常，请刷新后重新操作');
                }
            } else {
                that.$util.warningMsg('请先关闭扫码窗口');
            }
        },
        confirm(item) {
            let that = this;
            if (item.IsDelivery || item.IsAllNotOut) {
                if (!that.dialogScanVisible) {
                    if (item.OrderId) {
                        this.currentRow = item;
                        this.confirmVisible = true;
                    } else {
                        that.$util.warningMsg('订单信息异常，请刷新后重新操作');
                    }
                } else {
                    that.$util.warningMsg('请先关闭扫码窗口');
                }
            } else {
                that.$util.warningMsg('订单还未出仓，请待出仓后再进行确认');
            }
        },
        batchComfirms() {
            let that = this;
            if (that.idList.length > 0) {
                that.$confirm('您确定要将选中数据进行批量确认吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.confirmOrder(that.idList);
                    })
                    .catch(() => {});
            } else {
                that.$util.warningMsg('请先勾选订单再进行批量确认操作');
            }
        },
        confirmOrder(ids) {
            let that = this;
            if (ids && ids.length > 0) {
                that.$util
                    .axiosPost({
                        url: '/api/RevenueManagement_N/ConfirmSaleOrders',
                        data: {
                            OrderIds: ids
                        }
                    })
                    .then(res => {
                        that.firstScanOrder = true;
                        that.$util.successMsg('单据确认成功');
                        that.handleSearch();
                    })
                    .catch(() => {});
            } else {
                that.$util.warningMsg('订单信息异常，请刷新后重新操作');
            }
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'OrderCode':
                            this.columnShowSets.OrderCode.IsShow = item.IsShow;
                            this.columnShowSets.OrderCode.Width = item.Width;
                            this.columnShowSets.OrderCode.ColumnName = item.ColumnName;
                            break;
                        case 'EntpCusName':
                            this.columnShowSets.EntpCusName.IsShow = item.IsShow;
                            this.columnShowSets.EntpCusName.Width = item.Width;
                            this.columnShowSets.EntpCusName.ColumnName = item.ColumnName;
                            break;
                        case 'CallNum':
                            this.columnShowSets.CallNum.IsShow = item.IsShow;
                            this.columnShowSets.CallNum.Width = item.Width;
                            this.columnShowSets.CallNum.ColumnName = item.ColumnName;
                            break;
                        case 'Confirner':
                            this.columnShowSets.Confirner.IsShow = item.IsShow;
                            this.columnShowSets.Confirner.Width = item.Width;
                            this.columnShowSets.Confirner.ColumnName = item.ColumnName;
                            break;
                        case 'OutWarehouseStateName':
                            this.columnShowSets.OutWarehouseStateName.IsShow = item.IsShow;
                            this.columnShowSets.OutWarehouseStateName.Width = item.Width;
                            this.columnShowSets.OutWarehouseStateName.ColumnName = item.ColumnName;
                            break;
                        case 'OrderAmount':
                            this.columnShowSets.OrderAmount.IsShow = item.IsShow;
                            this.columnShowSets.OrderAmount.Width = item.Width;
                            this.columnShowSets.OrderAmount.ColumnName = item.ColumnName;
                            break;
                        case 'PayTypeName':
                            this.columnShowSets.PayTypeName.IsShow = item.IsShow;
                            this.columnShowSets.PayTypeName.Width = item.Width;
                            this.columnShowSets.PayTypeName.ColumnName = item.ColumnName;
                            break;
                        case 'DiscountAmount':
                            this.columnShowSets.DiscountAmount.IsShow = item.IsShow;
                            this.columnShowSets.DiscountAmount.Width = item.Width;
                            this.columnShowSets.DiscountAmount.ColumnName = item.ColumnName;
                            break;
                        case 'ShipAmount':
                            this.columnShowSets.ShipAmount.IsShow = item.IsShow;
                            this.columnShowSets.ShipAmount.Width = item.Width;
                            this.columnShowSets.ShipAmount.ColumnName = item.ColumnName;
                            break;
                        case 'CalcAmount':
                            this.columnShowSets.CalcAmount.IsShow = item.IsShow;
                            this.columnShowSets.CalcAmount.Width = item.Width;
                            this.columnShowSets.CalcAmount.ColumnName = item.ColumnName;
                            break;
                        case 'ConfirmTime':
                            this.columnShowSets.ConfirmTime.IsShow = item.IsShow;
                            this.columnShowSets.ConfirmTime.Width = item.Width;
                            this.columnShowSets.ConfirmTime.ColumnName = item.ColumnName;
                            break;
                        case 'Remark':
                            this.columnShowSets.Remark.IsShow = item.IsShow;
                            this.columnShowSets.Remark.Width = item.Width;
                            this.columnShowSets.Remark.ColumnName = item.ColumnName;
                            break;
                        case 'ConfirmStateName':
                            this.columnShowSets.ConfirmStateName.IsShow = item.IsShow;
                            this.columnShowSets.ConfirmStateName.Width = item.Width;
                            this.columnShowSets.ConfirmStateName.ColumnName = item.ColumnName;
                            break;
                        case 'SName':
                            this.columnShowSets.SName.IsShow = item.IsShow;
                            this.columnShowSets.SName.Width = item.Width;
                            this.columnShowSets.SName.ColumnName = item.ColumnName;
                            break;
                        case 'CreateTime':
                            this.columnShowSets.CreateTime.IsShow = item.IsShow;
                            this.columnShowSets.CreateTime.Width = item.Width;
                            this.columnShowSets.CreateTime.ColumnName = item.ColumnName;
                            break;
                        case 'OrderType':
                            this.columnShowSets.OrderType.IsShow = item.IsShow;
                            this.columnShowSets.OrderType.Width = item.Width;
                            this.columnShowSets.OrderType.ColumnName = item.ColumnName;
                            break;
                        case 'ActualMoney':
                            this.columnShowSets.ActualMoney.IsShow = item.IsShow;
                            this.columnShowSets.ActualMoney.Width = item.Width;
                            this.columnShowSets.ActualMoney.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.tableData = [];
            this.getTableData();
        },
        scanComfirms() {
            this.dialogScanVisible = true;
            this.inputblur();
        },
        // 失去焦点
        inputblur() {
            let that = this;
            // FireFox 和 IE 失去焦点，blur直接执行focus 不会生效，加个延时
            that.$nextTick(() => {
                if (that.$refs.inputdata) that.$refs.inputdata.focus();
            });
        },
        inputDataChange() {
            let that = this;
            that.resetSearch();
            if (that.scanData.indexOf('XS') > -1) {
                that.searchData.OrderCode = that.scanData;
                if (that.scanData.length == 17) {
                    if (that.firstScanOrder) {
                        that.tableData = [];
                    }
                    that.firstScanOrder = false;
                    that.$util
                        .axiosPost({
                            url: '/api/RevenueManagement_N/GetCusOrdersConfirmList',
                            data: that.searchData
                        })
                        .then(res => {
                            let data = res.data;
                            if (!data) {
                                if (that.searchData.page == 1) this.tableData = [];
                                return;
                            }
                            let list = [...that.tableData, ...data];
                            const maps = new Map();
                            list = list.filter(m => !maps.has(m.OrderId) && maps.set(m.OrderId, 1));
                            //因为接口的原因，返回前后两页数据有重复，所以在这里做去重
                            this.tableData = list;
                            that.tableData = list;
                            that.$nextTick(() => {
                                that.tableData.forEach(row => {
                                    that.$refs.multipleTable.toggleRowSelection(row, true);
                                });
                            });
                        });
                } else if (that.scanData.indexOf('XSTH') > -1 && that.scanData.length == 19) {
                    if (that.firstScanOrder) {
                        that.tableData = [];
                    }
                    that.firstScanOrder = false;
                    that.$util
                        .axiosPost({
                            url: '/api/RevenueManagement_N/GetCusOrdersConfirmList',
                            data: that.searchData
                        })
                        .then(res => {
                            let data = res.data;
                            if (!data) {
                                if (that.searchData.page == 1) this.tableData = [];
                                return;
                            }
                            let list = [...that.tableData, ...data];
                            const maps = new Map();
                            list = list.filter(m => !maps.has(m.OrderId) && maps.set(m.OrderId, 1));
                            that.tableData = list;
                            that.$nextTick(() => {
                                that.tableData.forEach(row => {
                                    that.$refs.multipleTable.toggleRowSelection(row, true);
                                });
                            });
                        });
                } else {
                    that.$util.warningMsg('销售单号/退货单号长度不符合规则！');
                }
            }
            that.scanData = '';
        },
        // 记录每行的key值,作用可以说是选中的不会清除，还有唯一性报错等问题
        getRowKeys(row) {
            return row.OrderId;
        },
        closeConfirm(args) {
            this.confirmVisible = false;
            if (args && args.length > 0) {
                let that = this;
                that.tableData.forEach(item => {
                    if (item.OrderId == that.currentRow.OrderId) {
                        item.IsCanStateBack = true;
                        item.ConfirmStateName = '已确认';
                        if (args[0]) {
                            item.PayTypeName = args[0].PayName;
                            item.Confirmer = args[0].UserName;
                            item.ConfirmTime = args[0].ConfirmTime;
                        }
                        if (args[1]) item.Paid = +args[1];
                        return;
                    }
                });
            }
        },
        selectInit(row, index) {
            //如果没有选中，要开放全部选择
            if (row.IsCanStateBack || (!row.IsDelivery && !row.IsAllNotOut)) return false;
            else return true;
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
#search-dc-dialog,
#scan-dc-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
.v-content {
    width: 100%;
    height: calc(100vh);
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.table-ctn {
    margin-bottom: 10px;
}
</style>
<style lang="less">
.outconfirm-content {
    .el-table {
        margin-bottom: 0px;

        th {
            padding: 4px 0;
        }
    }
    .detail-table {
        .el-table__body {
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 2px 0;
                }
            }
        }
    }
}
</style>
